// extracted by mini-css-extract-plugin
export default {"sidebar":"AccountSidebar_sidebar__aaOhQ","sidebarItem":"AccountSidebar_sidebarItem__Zywhn","active":"AccountSidebar_active__anPUA"};